module.exports = __webpack_public_path__ + "static/media/outcome.bb31a5f3.svg";